import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FunctionGpsAPIService } from '../API/FunctionGpsAPI.service';
@Injectable({
  providedIn: 'root'
})
export class FunctionGpsService{
  configUrl: string;
  headers: HttpHeaders;
  constructor(private funcitonGpsService: FunctionGpsAPIService) {
  }

  getReportHist(initialDate: string, finalDate: string, identifier: string = ""): any {
    return this.funcitonGpsService.getReportHist(initialDate, finalDate, identifier);
  }

  getReportHabits(initialDate: string, finalDate: string, identifier: string): any {
    return this.funcitonGpsService.getReportHabits(initialDate, finalDate, identifier);
  }

  getReportStatistics(initialDate: string, finalDate: string, identifier: string): any {
    return this.funcitonGpsService.getReportStatistics(initialDate, finalDate, identifier);
  }

}
